import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconDevicesStyle0 = gravityIconIndividualCss;

const GravityIconDevices = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'ebe08d27c6066ae9248a28632c961ee5ee106005', color: this.color, size: this.size }, h("svg", { key: '280bcae8e17969da3203668616e22528525176dc', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'e0f7654d07afb7d22e6ab1b3d27582bb5b86c0c4', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.5 13.5h-5v-8h14A.5.5 0 0 0 19 5v-.5a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V14a.5.5 0 0 0-.5-.5Zm3-5.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-7ZM16 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm2.5-3h-5V9.5h5V15Zm-12 2.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-3Z", fill: "currentColor" }))));
    }
};
GravityIconDevices.style = GravityIconDevicesStyle0;

export { GravityIconDevices as gravity_icon_devices };

//# sourceMappingURL=gravity-icon-devices.entry.js.map